import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertTriangleIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M9.9998 7.49824V10.8316M9.9998 14.1649H10.0081M8.8459 3.24134L1.99183 15.0802C1.61166 15.7369 1.42157 16.0652 1.44967 16.3347C1.47417 16.5697 1.59731 16.7833 1.78844 16.9222C2.00757 17.0816 2.38696 17.0816 3.14573 17.0816H16.8539C17.6126 17.0816 17.992 17.0816 18.2112 16.9222C18.4023 16.7833 18.5254 16.5697 18.5499 16.3347C18.578 16.0652 18.3879 15.7369 18.0078 15.0802L11.1537 3.24134C10.7749 2.58704 10.5855 2.25989 10.3384 2.15001C10.1228 2.05416 9.87677 2.05416 9.66122 2.15001C9.41411 2.25989 9.22471 2.58704 8.8459 3.24134Z"
        stroke="#FF5F57"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default AlertTriangleIcon;
